import React, { useState } from 'react';
import { requestPasswordReset } from '../utils/api';
import './Login.css';
import logo from '../assets/logo.png';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('');
    setLoading(true);

    try {
      await requestPasswordReset(email);
      setStatus('If the email exists, a reset link has been sent.');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">

              <img src={logo} alt="Company Logo" className="nav-logo" />
            </div>
            <p className="login-subtitle">Reset your password</p>
          </div>

          <form onSubmit={submit} className="login-form">
            {error && <div className="alert alert-error">{error}</div>}
            {status && <div className="alert alert-success">{status}</div>}

            <input
              type="email"
              className="input"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />

            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>

          <div className="login-footer">
            <a href="/login" className="login-link">Back to login</a>
          </div>

          <div className="login-background">
            <div className="bg-gradient"></div>
            <div className="bg-grid"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

